import { render, staticRenderFns } from "./facial_info_detail.vue?vue&type=template&id=6163f31c"
import script from "./facial_info_detail.vue?vue&type=script&lang=js"
export * from "./facial_info_detail.vue?vue&type=script&lang=js"
import style0 from "./facial_info_detail.vue?vue&type=style&index=0&id=6163f31c&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6163f31c')) {
      api.createRecord('6163f31c', component.options)
    } else {
      api.reload('6163f31c', component.options)
    }
    module.hot.accept("./facial_info_detail.vue?vue&type=template&id=6163f31c", function () {
      api.rerender('6163f31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/facialInfo/facial_info_detail.vue"
export default component.exports